import Container from '@/components/Container';
import { ResourceEntity } from '@/graphql/generated/graphql';
import { getAuthors } from '@/services/knowledge-hub/utils';
import Card from '@/components/Card';
import { useKnowledgeHubStore } from '../page/store/useKnowledgeHubStore';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import Divider from '@/components/Divider';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import { Link } from 'react-router-dom';

export function renderCards({
  title,
  data,
  viewAll = false,
  showDivider = true,
  viewAllText = 'View All',
}: {
  title: string;
  data: ResourceEntity[];
  showDivider?: boolean;
  viewAll?: boolean;
  viewAllText?: string;
}) {
  if (!data?.length) {
    return null;
  }

  const firstItem = data[0];

  return (
    <AnimatedFadeInComponent key={title}>
      <div key={title}>
        <div className="flex items-center justify-between">
          <h3 className="mb-sh-15 font-larken text-sh-md">{title}</h3>
          {viewAll ? (
            <Link
              className="text-sh-xxxs font-bold"
              to={`/knowledge-hub/topic/${firstItem.attributes?.themes?.data[0].attributes?.topic?.data?.attributes?.topic}`}>
              {viewAllText}
            </Link>
          ) : null}
        </div>
        <div className="grid grid-cols-1 gap-sh-30 md:grid-cols-2 md:gap-4">
          {data?.map((resource: ResourceEntity) => {
            return (
              <Card
                key={resource.id}
                title={resource.attributes?.title || ''}
                description={resource.attributes?.briefDescription || ''}
                author={getAuthors(resource)}
                link={`/knowledge-hub/slug/${resource.attributes?.slug}`}
                tags={
                  <DefaultContentTemplateTags
                    tags={[resource?.attributes?.resourceType?.data?.attributes?.type?.toString() || '']}
                    className="!mb-2 !mt-0"
                    duration={resource?.attributes?.duration || undefined}
                  />
                }
                image={{
                  url: resource.attributes?.cover.data?.attributes?.url || '',
                  alternativeText: resource.attributes?.cover.data?.attributes?.alternativeText || '',
                }}
              />
            );
          })}
        </div>
      </div>
      {showDivider ? <Divider /> : null}
    </AnimatedFadeInComponent>
  );
}

export default function KnowledgedHubMain() {
  const { latestResources, trendingResources, allTimeFavouriteResources } = useKnowledgeHubStore();

  return (
    <Container>
      <div className=" last-divider-hidden col-span-12 mt-sh-60 lg:col-start-11 lg:col-end-3">
        {renderCards({
          title: 'Trending this week',
          data: trendingResources,
          showDivider: latestResources?.length > 0,
        })}
        {renderCards({ title: 'Latest', data: latestResources, showDivider: allTimeFavouriteResources?.length > 0 })}
        {renderCards({
          title: 'All-time popular favourites',
          data: allTimeFavouriteResources,
          showDivider: false,
        })}
      </div>
    </Container>
  );
}
